import { readItems } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../services/directusClient/directusClient.ts';

export const useTargetAudiencesItemsQuery = () =>
  useQuery({
    queryKey: ['target_audiences'],
    queryFn: () => directusClient.request(readItems('target_audiences')),
  });
